import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeFilterType'
})
export class TimeFilterTypePipe implements PipeTransform {

    transform(value: string): any {
        if (!value) {
            return '';
        }
        if(value == "day"){
            return "DAILY";
        }
        if(value == "month"){
            return "DAILY";
        }
        if(value == "year"){
            return "MONTHLY";
        }

        return ((parseInt(value) - 280) * 100) / 140;
    }
}
